export default function FileUploadStatus(config) {
	if (!(this instanceof FileUploadStatus)) {
        return new FileUploadStatus(config);
	}
	this.config = Object.assign({
			uploading: false,
			uploadingFiles: [],
			statusContainer: '',
			statusMessage: '',
			progressBar: '',
			totalFiles: undefined,
			totalUploaded: undefined,
		},
		config
	);
}

/**
 * Returns the current status whether some file is uploaded or not.
 * 
 * @return	boolean		True when upload is in progress, false otherwise
 */
FileUploadStatus.prototype.isUploading = function() {
	return this.config.uploading;
};

FileUploadStatus.prototype.setTotalFiles = function(totalFiles, reRender = false) {
	this.config.totalFiles = totalFiles;
	this.config.totalUploaded = 0;

	if (reRender === true) {
		this.renderStatus();
	}
};

/**
 * Adds a new file to the internal list of files that are currently uploaded.
 * 
 * @param	string	fileName	The name of the file being uploaded
 * @param	boolean	reRender 	Optional, true by default, if false status is not re-rendered
 */
FileUploadStatus.prototype.uploading = function(fileName, reRender = true) {
	if (Object.keys(this.config.uploadingFiles).length === 0) {
		this.config.statusContainer.classList.remove('hidden');

		if (this.config.totalFiles !== undefined) {
			this.config.progressBar.classList.remove('hidden');
		}
	}
	this.config.uploadingFiles[fileName] = 1;
	this.config.uploading = true;

	if (reRender === true) {
		this.renderStatus();
	}
};

/**
 * Removes a file that is currently being uploaded.
 * 
 * @param	string	fileName	The name of the file that was uploaded
 * @param	boolean	reRender 	Optional, true by default, if false status is not re-rendered
 */
FileUploadStatus.prototype.finished = function(fileName, reRender = true) {
	delete this.config.uploadingFiles[fileName];
	++this.config.totalUploaded;

	if (this.config.totalUploaded == this.config.totalFiles) {
		this.config.uploading = false;
		this.config.statusContainer.classList.add('hidden');

		this.config.progressBar.classList.add('hidden');
		this.config.progressBar.style.width = '0%';
		this.config.totalFiles = undefined;
		this.config.totalUploaded = undefined;
	}

	if (reRender === true) {
		this.renderStatus();
	}
};

/**
 * Renders the HTML container with a new status message,
 * according to the current status.
 */
FileUploadStatus.prototype.renderStatus = function() {
	let files = Object.keys(this.config.uploadingFiles);
	if (files.length > 1) {
		this.config.statusMessage.innerText = `
			Hochladen von ${ files.slice(0, -1).reduce((v, prev) => (v.length > 0 ? `${ prev }, ${ v }` : prev), '') } 
			und ${ files.slice(-1) }...`;
	} else if (files.length === 1) {
		this.config.statusMessage.innerText = `Lade Datei ${ files.slice(-1) } hoch...`;
	} else {
		this.config.statusMessage.innerText = '';
	}

	if (this.config.totalFiles !== undefined) {
		let w = this.config.totalUploaded / this.config.totalFiles * 100;
		this.config.progressBar.style.width = `${ w }%`;
		if (w > 0.10) {
			this.config.progressBar.innerText = `${ w.toFixed(1) }%`;
		}
	}
}